<template>
  <section class="section">
    <div class="container">
      <div v-for="(item,index) in news" v-bind:key="item.id">
        <h2 class="is-size-2">{{ item.title }}</h2>
        <p>
          <span class="has-text-link">掲載期間：</span>
            <template v-if="!item.isNotPostingTerm">
              {{ item.from_date}} ～ {{ item.to_date}}
            </template>
            <template v-else>
              なし
            </template>
        </p>
        <p>
          <span class="has-text-link">グループ：</span>{{ item.group_name }}
        </p>
        <p>
          <span class="has-text-link">カテゴリ：</span>{{ item.category_name }}
        </p>
        <p>
          <span class="has-text-link">登録者：</span>{{ item.register }}
        </p>
        <template v-if="item.editor!== ''">
          <p>
            <span class="has-text-link">編集者：</span>{{ item.editor }}
          </p>
        </template>
        <p>
          <span class="has-text-link">内容：</span>
        </p>
        <div v-html="item.letter"></div>
        <div class="box">
          <LightBox
            ref="lightBox"
            :images="[{thumb: item.image, src: item.image, caption: '添付画像'}]"
            :show-light-box="false"
            :show-caption="false"
            :showThumbs="false">
          </LightBox>
          <img
              v-show="item.image"
              class="preview-item-file is-16by9"
              :src="item.image"
              alt="画像"
              @click="show(index)"
            />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import LightBox from 'vue-image-lightbox'

export default {
  props: {
    news_id: {
      type: Number,
      defualt: 0
    }
  },
  mounted(){
    this.$store.dispatch('news/getNewsDetails', { news_id: this.news_id })
  },
  components: {
    LightBox,
  },
  computed: {
    ...mapState({
      news (state) {
        this.$store.dispatch('status/setNewsEditItem', state.news.newsDetails[0])
        return state.news.newsDetails
      },
    }),
  },
  methods:{
    show: function(index){
      this.$refs["lightBox"][index].showImage(index)
    }
  }
}
</script>

<style scoped>
  .container {
    padding: 0 60px;
  }
</style>